import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Higher-Order Component that provides useNavigate hook functionality to class components
 * @param {React.Component} WrappedComponent - The class component to wrap
 * @returns {React.Component} - Enhanced component with navigate prop
 */
const WithNavigate = (WrappedComponent) => {
  const ComponentWithNavigate = (props) => {
    const navigate = useNavigate();
    
    return <WrappedComponent {...props} navigate={navigate} />;
  };
  
  // Set display name for debugging
  ComponentWithNavigate.displayName = `WithNavigate(${WrappedComponent.displayName || WrappedComponent.name})`;
  
  return ComponentWithNavigate;
};

export default WithNavigate; 